exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#vContainerStyle[data-v-847f61a0] {\n  height: 90vh;\n  overflow: auto;\n}\n", ""]);

// exports
